export const BUILDPC_V3_LOCAL_STORAGE_KEY = 'buildPc3';

export const BUILD_PC_MODAL_PAGE_SIZE = 20;

export const DEFAULT_PRICE_FILTER = { gte: 0, lte: 1000000000 };
